import {useStyles} from '../../../../../shared/hooks/styles';

export const useInfoTabMobileStyles = () => {
  return useStyles(({theme}) => ({
    cardInfo: {
      shadowColor: theme.color.shaddowBg,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowRadius: 10,
      paddingVertical: 16,
      paddingHorizontal: 32,
      alignItems: 'flex-start',
      borderColor: theme.color.borderColor,
      borderWidth: 2,
      borderRadius: 5,
      backgroundColor: theme.color.primaryNonGreyBackground,
      elevation: 5,
    },
    cardRow: {
      marginBottom: 10,
    },
    cardTitle: {
      fontSize: 16,
      lineHeight: 24,
      fontWeight: '600',
      color: theme.color.textColor,
    },
    cardText: {
      fontSize: 16,
      lineHeight: 30,
      color: theme.color.textColor,
    },
    cardPrimaryText: {
      fontSize: 16,
      lineHeight: 30,
      color: theme.color.primaryColor,
    },
    balance: {
      fontSize: 16,
      lineHeight: 30,
      color: theme.color.primaryColor,
      fontFamily: 'GothamPro',
    },
    subtitle: {
      fontSize: 18,
      lineHeight: 24,
      fontWeight: '600',
      borderBottomWidth: 1,
      borderColor: theme.color.borderColor,
      paddingBottom: 16,
    },
    truCardList: {
      alignItems: 'flex-start',
      width: '100%',
    },
    truCard: {
      marginTop: 10,
    },
    truRow: {
      paddingVertical: 16,
      borderBottomWidth: 1,
      borderColor: theme.color.borderColor,
      minWidth: '100%',
    },
    truName: {
      fontSize: 16,
      color: theme.color.textColor,
    },
  }));
};
